// Brazil
import br from './lists/br.json'
// Switzerland
import ch from './lists/ch.json'
// Germany
import de from './lists/de.json'
// Spain
import es from './lists/es.json'
// France
import fr from './lists/fr.json'
// UK
import gb from './lists/gb.json'
// Italy
import it from './lists/it.json'
// Mexico
import mx from './lists/mx.json'
// Portugal
import pt from './lists/pt.json'
// US
import us from './lists/us.json'

const regions = {
  br,
  ch,
  de,
  es,
  fr,
  gb,
  it,
  mx,
  pt,
  us,
} as const

export type Country = keyof typeof regions

export default regions
